import { makeStyles } from "@material-ui/core/styles";

export const PRIMARY_BACKGROUND = "#FAFAFA";
export const DEFAULT_BOX_SHADOW = "0px 0px 20px rgba(0, 0, 0, 0.15)";

export const PRIMARY_COLOR_BUTTON = "#296218";
export const MAX_WIDTH_PAPER = "180vh";

export const black = {
  800: "#1e293b",
};

export const STYLE_INPUT_WITH_SEARCH_ICON = {
  borderRight: "1px solid #EAEAEA",
  borderTop: "1px solid #EAEAEA",
  borderBottom: "1px solid #EAEAEA",
  borderLeft: "0",
  background: "#fff",
  padding: "0 0.8rem",
  cursor: "pointer",
  borderRadius: "0 6px 6px 0",
};

export const MINUS_WIDTH = 0;

export const STYLE_DEFAULT_MASTER = makeStyles({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    background: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "98%",
    margin: "0 auto",
  },
  inputButton: STYLE_INPUT_WITH_SEARCH_ICON,
});

export const STYLE_DEFAULT_TAB_BED = makeStyles({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    background: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});
